import { createContext, useContext, useState, useCallback } from "react";

const VerificationContext = createContext(null);

export const VerificationProvider = ({ children }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [step, setStep] = useState("idle"); // idle, loading, success, verified
    const [error, setError] = useState(null);
    const [returnUrl, setReturnUrl] = useState(null);
    const [mode, setMode] = useState("verify"); // verify, info_unverified, info_verified
    const [targetIsVerified, setTargetIsVerified] = useState(false);
    const [currentUserVerified, setCurrentUserVerified] = useState(false);

    const openVerification = useCallback((url = null, modeParam = "verify", verified = false, currentVerified = false) => {
        setIsOpen(true);
        setStep("idle");
        setError(null);
        if (url) setReturnUrl(url);
        setMode(modeParam);
        setTargetIsVerified(verified);
        setCurrentUserVerified(currentVerified);
    }, []);

    const closeVerification = useCallback(() => {
        setIsOpen(false);
        setStep("idle");
        setError(null);
        setReturnUrl(null);
        setMode("verify");
        setTargetIsVerified(false);
        setCurrentUserVerified(false);
    }, []);

    const setLoading = useCallback(() => {
        setStep("loading");
    }, []);

    const setSuccess = useCallback(() => {
        setStep("success");
    }, []);

    const setVerified = useCallback(() => {
        setStep("verified");
    }, []);

    const setErrorState = useCallback((err) => {
        setError(err);
        setStep("idle");
    }, []);

    return (
        <VerificationContext.Provider
            value={{
                isOpen,
                step,
                error,
                returnUrl,
                mode,
                targetIsVerified,
                currentUserVerified,
                openVerification,
                closeVerification,
                setLoading,
                setSuccess,
                setVerified,
                setError: setErrorState,
            }}
        >
            {children}
        </VerificationContext.Provider>
    );
};

export const useVerification = () => {
    const context = useContext(VerificationContext);
    if (!context) {
        throw new Error("useVerification must be used within a VerificationProvider");
    }
    return context;
};